<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-02 16:32:06
 * @LastEditTime: 2020-12-28 18:21:14
-->
<template>
  <div>
    <el-select style="width: 4rem" size="mini" value-key="id" v-model="selectContact" multiple clearable>
      <el-option
        v-for="item in contactList"
        :key="item.id"
        :label="item.name"
        :value="item">
      </el-option>
    </el-select>
    <el-button v-if="Permission.indexOf(260) !== -1" style="margin-left: 10px" size="mini" type="primary" @click="addContact">{{$t('lang.alarmNotice.Newcontact')}}</el-button>
    <cont-dialog ref="contDialog" @updateList="getList"></cont-dialog>
  </div>
</template>
<script>
import { getAlarmContact, deleteAlarmContact } from '@/api/cloudMonitor/alarmList'
import contDialog from '../../alarmContact/components/contDialog'
import { getPermission } from '@/cookie/cookie'

export default {
  props: {
    contact: {
      type: Array,
      default: () => []
    }
  },
  components: {
    contDialog
  },
  data() {
    return {
      contactList: [],
      selectContact: [],
      Permission: [],
    }
  },
  mounted() {
    this.getList()
    this.Permission = getPermission()
  },
  watch: {
   contact: {
     immediate: true,
     deep: true,
     handler() {
       if(this.contact.length > 0) {
         this.selectContact = this.contact
       }
     }
   }
  },
  methods: {
     // 获取联系人列表
    getList() {
      let params = {
        current: 1,
        size: 99999
      }
      getAlarmContact(params).then(res => {
        if(res.data.code === 0) {
          let data = res.data.data
          this.contactList = data.records
        }
      })
    },
    // 新建联系人
    addContact() {
      this.$refs.contDialog.show()
    },
    // 获取选择数据
    getContactData() {
      return this.selectContact
    }
  }
}
</script>